/* eslint-disable i18next/no-literal-string */
import {Text} from '@dropbox/dig-components/typography';
import {Stack} from '@dropbox/dig-foundations';
import type {AskHealthLowAnswer} from 'client';

import {AnswerRow} from './AnswerRow';
import {Panel} from './Panel';

export const LowestAnswers = ({answers}: {answers: AskHealthLowAnswer[]}) => (
  <Panel>
    <Stack gap="8">
      <Stack gap="2">
        <Text tagName="div" isBold>
          Lowest-scored answers, last 7 days
        </Text>
        <Text tagName="div" size="small" color="subtle">
          Click a question to see the answer and why the judge marked it down.
        </Text>
      </Stack>
      {answers.length === 0 ? (
        <Text tagName="div" size="small" color="subtle">
          No first answer scored below right and useful.
        </Text>
      ) : (
        <div>
          {answers.map((answer) => (
            <AnswerRow key={answer.trace_url} answer={answer} />
          ))}
        </div>
      )}
    </Stack>
  </Panel>
);
